import { Outlet } from "react-router";

import SettingsFunctionTypeCreateRoute from "../functionType/routes/SettingsFunctionTypeCreateRoute";
import SettingsFunctionTypeEditRoute from "../functionType/routes/SettingsFunctionTypeEditRoute";
import SettingsObservationTypeCreateRoute from "../observationType/routes/SettingsObservationTypeCreateRoute";
import SettingsObservationTypeEditRoute from "../observationType/routes/SettingsObservationTypeEditRoute";
import SettingsResearchTypeCreateRoute from "./routes/SettingsResearchTypeCreateRoute";
import SettingsResearchTypeEditRoute, { ResearchTypeEditScreenBreadcrumb } from "./routes/SettingsResearchTypeEditRoute";
import SettingsResearchTypeListRoute from "./routes/SettingsResearchTypeListRoute";

export const researchTypeRoutes = [
    {
        path: "researchType",
        handle: { breadcrumb: "researchType:settingsResearchTypeListRoute.title" },
        element: <Outlet />,
        children: [
            { index: true, element: <SettingsResearchTypeListRoute /> },
            {
                path: "new",
                handle: { breadcrumb: "researchType:settingsResearchTypeCreateRoute.title" },
                element: <SettingsResearchTypeCreateRoute />,
            },
            {
                path: ":researchTypeId",
                handle: { breadcrumb: ResearchTypeEditScreenBreadcrumb },
                children: [
                    {
                        index: true,
                        element: <SettingsResearchTypeEditRoute />,
                    },
                    {
                        path: "observationType/new",
                        handle: { breadcrumb: "observationType:settingsObservationTypeCreateRoute.title" },
                        element: <SettingsObservationTypeCreateRoute />,
                    },
                    {
                        path: "observationType/:observationTypeId",
                        handle: { breadcrumb: "observationType:settingsObservationTypeEditRoute.title" },
                        element: <SettingsObservationTypeEditRoute />,
                    },
                    {
                        path: "functionType/new",
                        handle: { breadcrumb: "functionType:settingsFunctionTypeCreateRoute.title" },
                        element: <SettingsFunctionTypeCreateRoute />,
                    },
                    {
                        path: "functionType/:functionTypeId",
                        handle: { breadcrumb: "functionType:settingsFunctionTypeEditRoute.title" },
                        element: <SettingsFunctionTypeEditRoute />,
                    },
                ],
            },
        ],
    },
];
